import { useNavigate } from "react-router-dom";

import Container from "@vfuk/core-container";
import Divider from "@vfuk/core-divider";
import LinkWithIcon from "@vfuk/core-link-with-icon";
import Spacing from "@vfuk/core-spacing";

import Greetings from "./Greetings";
import { useProfileModal } from "./hooks/useProfileModal";

const ProfileView = () => {
  const navigate = useNavigate();
  const { setView, navbarUser } = useProfileModal(); //baseUrl
  const { email, initials, name, role } = navbarUser;

  const handleLogout = () => {
    navigate("/logout");
  };

  return (
    <Container appearance="primary">
      <div>
        <Greetings name={name} email={email} initials={initials} role={role} />
      </div>
      <Spacing
        spacingLevel={{
          top: 9,
        }}
      >
        <LinkWithIcon
          appearance="secondary"
          text="Profile management"
          icon={{
            name: "profile",
            justify: "left",
          }}
          onClick={() => setView("EDIT_PROFILE")}
          size={3}
        />
      </Spacing>
      <Divider level={1} />
      <Spacing
        spacingLevel={{
          top: 4,
        }}
      >
        <LinkWithIcon
          appearance="secondary"
          text="Logout"
          onClick={handleLogout}
          icon={{
            name: "log-out",
            justify: "left",
          }}
          size={3}
        />
      </Spacing>
      <Divider />
    </Container>
  );
};

export default ProfileView;
